import type { TwitterCampaignWithLineItems, TwitterLineItemEntry } from '../api/types';

export interface TwitterCampaignRow extends TwitterCampaignWithLineItems {
  isLineItem?: false;
}

export interface TwitterLineItemRow extends TwitterLineItemEntry {
  campaign_id: string;
  campaign_name: string;
  account_id: string;
  isLineItem: true;
}

export type TwitterGridRow = TwitterCampaignRow | TwitterLineItemRow;

export const isTwitterLineItemRow = (row: TwitterGridRow): row is TwitterLineItemRow =>
  row.isLineItem === true;

export const getTwitterGridRowId = (row: TwitterGridRow): string =>
  isTwitterLineItemRow(row) ? row.line_item_id : row.campaign_id;
